import {useCallback, useEffect, useState} from "react";
import {appendUniqueMessage} from "./messageState";

const useSocket = ({socket, selectedConversation}) => {
  const [notificationRemoteList, setNotificationRemoteList] = useState([]);
  const [messageRemoteList, setMessageRemoteList] = useState([]);

  const addMessage = (message) => {
    if (!message?.id) return;
    setMessageRemoteList((previous) => appendUniqueMessage(previous, message));
  };

  // Connect the socket with auth
  const connectSocket = useCallback(() => {
    if (!socket.connected) {
      const token = localStorage.getItem("token");
      if (token) {
        socket.auth = {authorization: `Bearer ${token}`};
        socket.connect();
      } else {
        // No token found
      }
    }
  }, [socket]);

  // Generalized data handler
  const handleDataUpdate = (data, setData) => {
    if (!data) return;
    if (Array.isArray(data)) {
      setData(data);
    } else {
      setData((previous) => appendUniqueMessage(previous, data));
    }
  };

  useEffect(() => {
    // Connect on mount
    connectSocket();

    // Event listeners
    const handleNotification = (data) =>
      handleDataUpdate(data, setNotificationRemoteList);
    const handleMessage = (data) => {
      handleDataUpdate(data, setMessageRemoteList);
    };
    const handleConnectError = () => {
      // The shared Socket.IO client retries automatically. MainChat exposes
      // the room-level error if joining still fails after reconnection.
    };

    socket.on("receive_notif", handleNotification);
    socket.on("receive_message", handleMessage);

    socket.on("connect_error", handleConnectError);

    // Cleanup on unmount
    return () => {
      socket.off("receive_notif", handleNotification);
      socket.off("receive_message", handleMessage);
      socket.off("connect_error", handleConnectError);
      // The global application listener owns the shared socket connection.
    };
  }, [socket, connectSocket]);

  return {
    notificationRemoteList,
    messageRemoteList,
    addMessage,
    connectSocket,
  };
};

export default useSocket;
